export default ({ request }) => ({
  masterBrandListApi(data) {
    return request({
      url: '/digitalCenter/masterbrand/list',
      method: 'post',
      data,
    })
  },
  masterBrandDetailApi(data) {
    return request({
      url: '/digitalCenter/masterbrand/detail',
      method: 'post',
      data,
    })
  },
  masterBrandSaveApi(data) {
    return request({
      url: '/digitalCenter/masterbrand/save',
      method: 'post',
      data,
    })
  },
  masterBrandDelApi(data) {
    return request({
      url: '/digitalCenter/masterbrand/del',
      method: 'post',
      data,
    })
  },
  masterBrandExistApi(brandName) {
    return request({
      url: `/digitalCenter/masterbrand/exist/${brandName}`,
      method: 'GET',
    })
  },
})
